<template>
  <div class="crops-finder">
    <div class="row">
      <div class="column">
        <div class="crops-finder__content">
          <h2>{{ title }}</h2>
          <template v-if="description">
            <p>{{ description }}</p>
          </template>

          <div class="crops-finder__crops">
            <div class="crops-finder__crops-info">
              <transition-group name="slide-in" tag="div">
                <a
                  href="#"
                  v-if="activeCropId !== 0"
                  @click.prevent="activeCropId = 0"
                  key="link">
                  {{ activeCrop.title }}
                </a>
                <span key="text">
                  {{ activeCropId === 0 ? t.selectCategory : t.selectCrop }}
                </span>
              </transition-group>
            </div>

            <div class="crops-finder__container">
              <transition name="slide-main" mode="out-in" appear>
                <!-- main crops -->
                <div
                  v-if="activeCropId === 0"
                  class="crops-finder__crops-container-main">
                  <div
                    v-for="crop in crops"
                    :key="crop.id"
                    class="crops-finder__crop crops-finder__crop--main"
                    @mouseover="activeCropHoverId = crop.id"
                    @click="activeCropId = crop.id">
                    <div class="crops-finder__crop-image">
                      <img
                        :src="crop.icon"
                        :alt="crop.title"
                        class="responsive-image__img" />
                    </div>
                    {{ crop.title }}
                  </div>
                </div>
              </transition>

              <transition name="slide-sub" mode="out-in">
                <!-- sub crops -->
                <div v-if="activeCropId !== 0">
                  <div class="crops-finder__crops-container-sub">
                    <a
                      v-for="crop in subCrops"
                      :key="crop.id"
                      :href="crop.url"
                      class="crops-finder__crop crops-finder__crop--sub">
                      {{ crop.title }}
                    </a>
                  </div>

                  <div class="crops-finder__crops-link">
                    <a :href="activeCrop.url" class="button">
                      {{ `${t.visit} ${activeCrop.title}` }}
                    </a>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <div class="column" v-if="!isMobile">
        <!-- crop images -->
        <!-- we stack images to make sure the transition is smoother -->
        <div class="crops-finder__images">
          <div
            v-for="crop in crops"
            :key="crop.id"
            class="crops-finder__image"
            :class="{
              'crops-finder__image--active': activeCropHoverId === crop.id,
            }">
            <responsive-image :images="crop.image" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// components
import ResponsiveImage from './elements/ResponsiveImage';
// utils
import { isMobile } from '../utils/isMobile';
import translationStrings from '../translations/translationStrings';

export default {
  name: 'crops-finder',
  components: {
    ResponsiveImage,
  },
  props: {
    allCrops: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      activeCropId: 0,
      activeCropHoverId: 0,
      isMobile: isMobile(),
      t: translationStrings,
    };
  },
  computed: {
    crops() {
      // need to do sorting here bc it is
      // correctly sorted in BE already
      return Object.values(this.allCrops).sort(
        (a, b) => a.weight - b.weight || a.title.localCompare(b.title),
      );
    },
    subCrops() {
      return this.activeCrop.length === 0
        ? this.activeHoverCrop.sub_crops
        : this.activeCrop.sub_crops;
    },
    activeCrop() {
      return this.allCrops[this.activeCropId]
        ? this.allCrops[this.activeCropId]
        : [];
    },
    activeHoverCrop() {
      return this.allCrops[this.activeCropHoverId]
        ? this.allCrops[this.activeCropHoverId]
        : [];
    },
  },
  watch: {
    activeCropId(value, oldValue) {
      this.activeCropHoverId = value === 0 ? oldValue : value;
    },
  },
  mounted() {
    // set the first image as the default one
    this.activeCropHoverId = this.crops ? this.crops[0].id : 0;

    window.addEventListener('resize', () => {
      this.isMobile = isMobile();
    });
  },
};
</script>
